import React from 'react';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import analyticsService from '~/src/services/analytics';
import { tryConvertToNumber } from '~/src/entities/questionnaires';
import { AiGemIcon } from '~/src/components/icons';

export const AIDraftingBanner = ({
  open,
  questionnaireId,
  onClose,
}: {
  open: boolean;
  questionnaireId: string;
  onClose: () => void;
}) => {
  const handleOnClose = () => {
    analyticsService.track('Clicked on Banner Close', {
      questionnaire_id: tryConvertToNumber(questionnaireId),
      banner_type: 'info',
      page: 'documents_select_page',
      sub_page: null,
    });
    onClose();
  };

  if (!open) return null;

  return (
    <div className="mb-12 rounded-lg border border-gray-200">
      <div className="py-3 px-4 flex flex-col gap-2 rounded-lg bg-white">
        <div className="flex items-center justify-between">
          <div className="font-semibold text-sm flex items-center gap-2 text-slate-700">
            <AiGemIcon className="w-5 h-5 flex-shrink-0" />
            Generate a questionnaire based on the templates you need to draft
          </div>
          <IconButton aria-label="close" size="small" onClick={handleOnClose}>
            <Close fontSize="small" />
          </IconButton>
        </div>
        <div className="text-sm ml-7">
          Have AI automatically create the needed questions for you based on
          selected templates.
        </div>
      </div>
    </div>
  );
};
